import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/urls.service";
import * as i2 from "Angular/services/core/ajax.service";
/**
 * Service for performing operations on folders.
 *
 * Used to perform the following operations:
 * - Create folder
 * - Delete folder
 * - Rename folder
 * - Move folder
 * - Move file into folder
 */
export class FolderOperationsService {
    constructor(urlsService, ajaxService) {
        this.urlsService = urlsService;
        this.ajaxService = ajaxService;
    }
    getFolders(queryParams) {
        return this.ajaxService.getDataObserveBody(this.urlsService.FOLDERS.COLLECTION, queryParams);
    }
    createFolder(postParams) {
        return this.ajaxService.postFormEncodedDataObserveBody(this.urlsService.FOLDERS.COLLECTION, postParams);
    }
    moveFolderableItem(itemType, itemId, targetFolderId) {
        const url = this.urlsService.getUrl(this.urlsService.FOLDERS.FOLDER_ITEM, { itemType, itemId });
        // If the `targetFolderId` is null, then the user is trying to orphan the folderable item.
        if (targetFolderId === null) {
            return this.ajaxService.putDataObserveBody(url, {});
        }
        return this.ajaxService.putDataObserveBody(url, { targetFolderId });
    }
    bulkMoveFolderableItems(idsByResourceType, targetFolderId) {
        const url = this.urlsService.getUrl(this.urlsService.FOLDERS.FOLDER_ITEM_BULK_MOVE);
        // JSON.stringify does not serialize sets properly. Convert Sets to Arrays for proper serialization.
        const serializedIdsByResourceType = Object.entries(idsByResourceType).reduce((acc, [key, value]) => {
            acc[key] = Array.from(value);
            return acc;
        }, {});
        // If the `targetFolderId` is null, then the user is trying to bulk orphan the folderable items.
        if (targetFolderId === null) {
            return this.ajaxService.putDataObserveBody(url, {
                ids_by_resource_type: serializedIdsByResourceType,
            });
        }
        return this.ajaxService.putDataObserveBody(url, {
            folder_id: targetFolderId,
            ids_by_resource_type: serializedIdsByResourceType,
        });
    }
    deleteFolder(id) {
        const url = this.urlsService.getUrl(this.urlsService.FOLDERS.FOLDER, { folderId: id });
        return this.ajaxService.deleteDataObserveBody(url);
    }
    deleteFolderable(itemType, itemId) {
        const url = this.urlsService.getUrl(this.urlsService.FOLDERS.FOLDERABLE, { itemType, itemId });
        return this.ajaxService.deleteDataObserveBody(url);
    }
    renameFolderableItem(itemType, itemId, name) {
        const url = this.urlsService.getUrl(this.urlsService.FOLDERS.FOLDERABLE_RENAME, { itemType, itemId });
        return this.ajaxService.putDataObserveBody(url, { name });
    }
}
FolderOperationsService.ɵfac = function FolderOperationsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderOperationsService)(i0.ɵɵinject(i1.UrlsService), i0.ɵɵinject(i2.AjaxService)); };
FolderOperationsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FolderOperationsService, factory: FolderOperationsService.ɵfac, providedIn: 'root' });
